import React from 'react';
import { NavLink } from 'react-router-dom';
import Section from './Section.jsx';

class About extends React.Component {
  render() {
    return (
      <Section>
        <h1>ABOUT</h1>
        <div className="pBox">
          <p>Hello!</p>
          <p>I am a Vancouver-based web developer specializing in JavaScript.</p>
          <p>I have several years of professional experience developing skills in these areas:</p>
          <p>JavaScript, React, Redux, jQuery, CSS, Sass, Swift, Objective-C, Java, PHP, Node, Webpack, Babel, MySQL, SQLite, Salesforce, Google APIs, Hybrid App Development, Chrome Extension Development, and more!</p>
        </div>
        <div className="colorBox"></div>
      </Section>
    )
  }
}

export default About;
